import { render, staticRenderFns } from "./PeselSearch.vue?vue&type=template&id=226e60f8&"
import script from "./PeselSearch.vue?vue&type=script&lang=js&"
export * from "./PeselSearch.vue?vue&type=script&lang=js&"
import style0 from "./PeselSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports